export function Avatar({ src, name, size = 36, className = "" }) {
  const initials = (name || "?")
    .split(" ")
    .filter(Boolean)
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const px = { width: size, height: size };
  if (src) {
    return (
      <img
        src={src}
        alt=""
        style={px}
        className={`rounded-full object-cover border border-white/10 shrink-0 ${className}`}
      />
    );
  }
  const fontSize = Math.max(10, Math.floor(size * 0.36));
  return (
    <div
      style={{ ...px, fontSize }}
      className={`rounded-full bg-[#CCFF00]/10 border border-[#CCFF00]/40 text-[#CCFF00] flex items-center justify-center font-bold shrink-0 ${className}`}
    >
      {initials}
    </div>
  );
}

// Read a File as data URL, resized to a square via canvas if too big.
// Returns a Promise<string> of the compressed data URI.
export async function fileToCompressedDataUri(file, { maxSize = 512, quality = 0.85 } = {}) {
  const rawDataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("read failed"));
    reader.readAsDataURL(file);
  });
  const img = await new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = () => reject(new Error("decode failed"));
    i.src = rawDataUrl;
  });
  const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
  const w = Math.round(img.width * scale);
  const h = Math.round(img.height * scale);
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);
  return canvas.toDataURL("image/jpeg", quality);
}
